module.exports = __webpack_public_path__ + "static/media/evolution_94.e7d5da90.svg";